import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// AG-GRID License
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-063601}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Edriving_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_September_2025}____[v3]_[01]_MTc1ODA2MzYwMDAwMA==4c0555359735dde56345b8d9f7de16b4'
);

if (environment.production || environment.preProduction || environment.staging) {
  enableProdMode();

  // Don't log to console in production
  if (window) {
    const consolePropKeys = Object.keys(window.console);
    consolePropKeys.forEach((key) => {
      if (typeof window.console[key] === 'function') {
        window.console[key] = function () {};
      }
    });
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
